import React from 'react'

const Demo2 = () => {
  return (
    <div
        className='border border-black h-96 w-96 m-2 p-2'
    >Demo2</div>
  )
}

export default Demo2